$('header.main .actions .bars').on('click', (e) => {
  e.preventDefault();
  $('nav.main').toggleClass('is');
});

$('nav.main .close').on('click', (e) => {
  $('nav.main').removeClass('is');
});

$('.categories select').on('change', (e) => {
  e.preventDefault();
  let select = $(e.target);
  let url = select.val();

  if (url) {
    window.location.href = url;
  }
});



// WEBPACK FOOTER //
// ./src/js/components/navigation.js